module.exports = __webpack_public_path__ + "media/images/connected-6-4a109737066332d59b6f75df58cdde4a.jpg";